export default "__VITE_ASSET__Dh1NQdg2__"